import App from "../App";
import debugModel from "../../src/model/DebugModel";
import GameModel from "../model/GameModel";

export default class DebugMenu {
    protected container: HTMLElement;
    public menu: HTMLDivElement;
    protected menuBtn: HTMLDivElement;
    protected fps: HTMLDivElement;
    protected icon: HTMLElement;
    protected content: HTMLDivElement;
    protected isOpened: boolean;
    protected app: App;

    constructor(container: HTMLElement) {
        if (GameModel.urlParams.removeDebug == "true") {
            return;
        }
        this.menu = document.createElement("div");
        this.menuBtn = document.createElement("div");
        this.icon =  document.createElement("i");
        this.icon.classList.add("wiener_icon");
        this.content = document.createElement("div");
        this.menu.appendChild(this.menuBtn);
        this.menu.appendChild(this.content);
        container.appendChild(this.menu);
        this.menuBtn.appendChild(this.icon);
        this.menu.classList.add("wiener_debugMenu");
        this.menuBtn.classList.add("wiener_debugBtn");
        this.content.classList.add("wiener_debuContent");
        this.closeMenu();

        this.menuBtn.addEventListener("click", this.toggleMenu.bind(this));
        // if (App.config.showFPS) {
            this.fps = document.createElement("div");
            this.fps.classList.add("wiener_debugMenu_fps");
            this.menuBtn.appendChild(this.fps);
            App.instance.ticker.add(() => {
                this.fps.innerHTML =  Math.round(App.instance.ticker.FPS).toString();
            });
        // }
    }

    //  /**
    //   * Add Input field to debug menu debug preset case with a callback
    //   * @param debugCaseName
    //   * @param callback:string->void
    //   */
    // addDebugCase(debugCaseName: string, callback: ( ...args: any[] ) => void) {
    //     const item = document.createElement("div");
    //     item.innerHTML  = "<p>" + debugCaseName + "</p>";
    //     item.classList.add("wiener_debug_item");
    //     this.content.appendChild(item);
    //     item.addEventListener("click", () => {
    //         callback();
    //         this.toggleMenu();
    //     });
    // }

     /**
      * Add Input field to debug menu debug preset case with a callback
      * @param debugCaseName
      * @param data:any
      */
     addDebugCase(debugCaseName: string, data: any, special: boolean) {
        const item = document.createElement("div");
        item.innerHTML  = "<p>" + debugCaseName + "</p>";
        item.classList.add("wiener_debug_item");
        this.content.appendChild(item);
        item.addEventListener("click", () => {
            // callback();
            debugModel.currentDebugCase = debugCaseName;
            debugModel.debugData = data;
            debugModel.special = special
            this.toggleMenu();
        });
    }

    /**
     * Add Input field to debug menue
     * @param inputName
     * @param callback:string->void
     */
    addDebugInput(debugCaseName: string) {
        const item = document.createElement("div");
        item.innerHTML  = "<p>" + debugCaseName + "</p>";
        item.classList.add("wiener_debug_item");
        this.content.appendChild(item);
        item.addEventListener("click", () => {
            const input = prompt("Enter Debug string:");
            if (input) {
                // callback(input);
                debugModel.currentDebugCase = debugCaseName;
                debugModel.debugData = input;
                this.toggleMenu();
            }
        });
    }

    toggleMenu() {
        if (this.isOpened) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.icon.classList.remove("bug");
        this.icon.classList.add("close");
        this.menu.classList.remove("wiener_debugMenu_closed");
        this.menu.classList.add("wiener_debugMenu_opened");
        this.isOpened = true;
    }

    closeMenu() {
        this.icon.classList.remove("close");
        this.icon.classList.add("bug");
        this.menu.classList.remove("wiener_debugMenu_opened");
        this.menu.classList.add("wiener_debugMenu_closed");
        this.isOpened = false;
    }
}
